export default __webpack_public_path__ + "static/media/NoContentImg.6d20e71b.png";